export const qualify_items = {
    "overall_assessment": {
        "title": "Overall Eligibility",
        "items": {
            "eligibility": {
                "title": "Overall Eligibility for R&D",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": [
                    ["baseline_research", "baseline_statements"],
                    ["baseline_research", "internet_search"],
                    ["baseline_research", "feedback"],
                    ["risk_factors", "risk_factors"],
                    ["risk_factors", "uncertainty_check"],
                    ["risk_factors", "qualifying_activity"],
                ],
            }
        }
    }, 
    "baseline_research": {
        "title": "Prior Art Research",
        "items": {
            "baseline_statements": {
                "title": "Assumptions on Prior Art & Shortcomings",
                "selected_model": "gpt-4o",
                "use_files": true,  
                "dependencies": []
            },
            "internet_search": {
                "title": "Internet Search",
                "selected_model": "sonar",
                "use_files": false,
                "dependencies": [
                    ["baseline_research", "baseline_statements"]
                ]
            },
            "feedback": {
                "title": "Feedback",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": [
                    ["baseline_research", "baseline_statements"],
                    ["baseline_research", "internet_search"]
                ],
            }
        }
    },
    "risk_factors": {
        "title": "Other Eligibility Criteria",
        "items": {
            "risk_factors": {
                "title": "Riskss",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": []
                            },
            "uncertainty_check":{
                "title": "Uncertainty",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": []
                            },
            "qualifying_activity":{
                "title": "R&D Activities",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": []
            }
        }
    },
    "questions_for_client": {
        "title": "Questions for Client",
        "items": {
            "research": {
                "title": "Prior Art Research",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": [
                    ["baseline_research", "baseline_statements"],
                    ["baseline_research", "internet_search"],
                    ["baseline_research", "feedback"],
                ],
            },
            "risk_factors": {
                "title": "Other Eligibility Criteria",
                "selected_model": "gpt-4o",
                "use_files": true,
                "dependencies": [
                    ["risk_factors", "risk_factors"],
                    ["risk_factors", "uncertainty_check"],
                    ["risk_factors", "qualifying_activity"],
                ],
            },
        }
    }
}
